import { navigate } from "svelte-navigator";
import { isLocalhost } from "./app/config";
const pageUrl = {
    HOME: "/",
    SIGNIN: "/login",
    SIGNOUT: "/logout",
    REGISTER: "/register",
    BLOG: "/blog",
    CAREERS: "/careers",
    USER_INFO: "/userinformation",
    PASSWORD_RECOVERY: "/passwordrecovery",
    RESET_PASSWORD: "/resetpassword",
    TWOFACTOR_AUTHENTICATION: "/authentication",
    TERM_OF_SERVICE: "https://google.com",
    PRIVACY_POLICY: "https://google.com",
    COOKIE_USE: "https://google.com",
    // Ui page
    UI_PAGE: !isLocalhost
        ? "https://ui.datadocs.com"
        : "http://localhost:8080",
};
export function redirectTo(url, search = {}, reload = false, options = {}) {
    if (url && typeof url === "string") {
        const searchParams = (new URLSearchParams(search)).toString();
        url = searchParams ? [url, searchParams].join("?") : url;
        if (reload) {
            window.location.replace(url);
        }
        else {
            navigate(url, options);
        }
    }
}
export default pageUrl;
